import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmgBusyIndicatorComponent } from './components/cmg-busy-indicator/cmg-busy-indicator.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DrawerModule } from 'primeng/drawer';
import { CmgDecimalInputComponent } from './components/cmg-decimal-input/cmg-decimal-input.component';
import { SafePipe } from './safe.pipe';
import { CmgSplitButtonComponent } from './components/cmg-split-button/cmg-split-button.component';
import { ReadOnlyValidationDirective } from './read-only-validation.directive';
import { CmgHighlightDirective } from './directives/cmg-highlight.directive';

@NgModule({
  imports: [
    CmgBusyIndicatorComponent,
    CmgDecimalInputComponent,
    CmgHighlightDirective,
    CmgSplitButtonComponent,
    ReadOnlyValidationDirective,
    SafePipe,

    CommonModule,
    AccordionModule,
    ButtonModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    DrawerModule,
    ScrollPanelModule,
    RouterModule,
    ReactiveFormsModule,
  ],
  exports: [
    CmgBusyIndicatorComponent,
    CmgDecimalInputComponent,
    CmgHighlightDirective,
    CmgSplitButtonComponent,
    ReadOnlyValidationDirective,
    SafePipe,
  ],
})
export class UiModule {}
